
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/prepaid-credits",
      function () {
        return require("private-next-pages/prepaid-credits/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/prepaid-credits"])
      });
    }
  